
import lead from "./lead";
import enqPricing from "./enqPricing";

export const mobile_sideBarItems = [
    lead,
    enqPricing,
];


// WEBPACK FOOTER //
// ./src/sidebar/mobile_index.js